// Removed <a href> on slider images per allyant and are usng js to make images clickable

document.addEventListener('DOMContentLoaded', () => {
  const blogImages = document.querySelectorAll('[data-custom-href]');

  blogImages.forEach(image => {
  
    image.addEventListener('click', () => {
      window.location.href = image.dataset.customHref
    });
  
  });
});